import com from '../../../../../comMapping.js'
export function getdata() {
	let obj = {
		headData: [{
				title: '任务名称',
				prop: 'name',
				width: '280',
				issort: true,
				align:"left",
				custom:true,
			},
			{
				title: '定时任务状态',
				prop: 'status',
				width: '160',
				custom:true,
				showFilter: true,
				checkList: com.lqdsrwStatus.map(item=>item.code),
				dataList: com.lqdsrwStatus
			},
			{
				title: '最近执行时间',
				prop: 'lastTime',
				width: '160',
				issort: true,
			},
			{
				title: '修改时间',
				prop: 'updateTime',
				width: '160',
				issort: true,
			},
			{
				title: '操作人',
				prop: 'operator',
				width: '160',
				issort: true,
			},
			{
				title: '操作',
				prop: 'cz',
				width: '160',
				fixed:"right",
				custom:true,

			}
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}